import { Link } from 'react-router-dom';
import { WHATSAPP_URL } from '../../constants/whatsapp';

const PRODUCT_LINKS = [
  { label: 'Medical Gloves', href: '/medical-gloves' },
  { label: 'Food Grade Gloves', href: '/food-grade-gloves' },
  { label: 'Lab Gloves', href: '/lab-gloves' },
  { label: 'Industrial Gloves', href: '/industrial-gloves' },
];

export default function Footer() {
  return (
    <footer className="bg-navy text-white">
      {/* Top CTA Strip */}
      <div className="bg-brand-green py-6 px-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left">
            <p className="font-heading font-bold text-white text-lg md:text-xl">
              Ready to Order? Get Wholesale Pricing in Minutes.
            </p>
            <p className="font-arabic text-white/90 text-base mt-0.5" dir="rtl">
              هل أنت مستعد للطلب؟ احصل على أسعار الجملة في دقائق.
            </p>
          </div>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-white text-brand-green font-heading font-bold px-6 py-3 rounded-full 
                       hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer shadow-md"
          >
            <i className="ri-whatsapp-line text-xl" />
            WhatsApp Now
          </a>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/f61ec8f8-da21-40a5-ac46-7cf45d15eb9b.png"
                alt="omandisposables.com"
                className="h-12 w-auto object-contain"
              />
              <div>
                <p className="font-heading font-bold text-white text-lg">omandisposables.com</p>
                <p className="text-brand-green text-sm font-semibold">🇴🇲 Oman Based | Trusted Wholesale</p>
              </div>
            </div>
            <p className="text-white/85 text-sm leading-relaxed max-w-sm mb-2">
              Quality Supply. Rooted in Oman. Trusted by 500+ clients across Oman and the GCC for
              wholesale disposable gloves supply.
            </p>
            <p className="font-arabic text-white/85 text-sm leading-relaxed text-right" dir="rtl">
              جودة موثوقة. راسخون في عُمان. يثق بنا أكثر من 500 عميل عبر عُمان ودول الخليج.
            </p>
            <div className="flex gap-3 mt-5">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-whatsapp/20 text-whatsapp hover:bg-whatsapp hover:text-white transition-all cursor-pointer"
                aria-label="Contact omandisposables.com on WhatsApp (opens in new tab)"
              >
                <i className="ri-whatsapp-line text-lg" />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-wider">
              <a id="footer-products" href="#footer-products">Products</a>
            </h4>
            <ul className="space-y-2.5">
              {PRODUCT_LINKS.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/85 hover:text-brand-green text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-wider">
              <a id="footer-company" href="#footer-company">Company</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-white/85 hover:text-brand-green text-sm transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/bulk-wholesale" className="text-white/85 hover:text-brand-green text-sm transition-colors cursor-pointer">
                  Bulk &amp; Wholesale
                </Link>
              </li>
              <li>
                <Link to="/request-quote" className="text-white/85 hover:text-brand-green text-sm transition-colors cursor-pointer">
                  Request a Quote
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-white/85 hover:text-brand-green text-sm transition-colors cursor-pointer">
                  Privacy Policy
                </Link>
              </li>
            </ul>
            <div className="mt-6 pt-6 border-t border-white/10">
              <p className="text-white/75 text-xs">🇴🇲 Based in Muscat, Oman</p>
              <p className="text-white/75 text-xs mt-1">🌍 Supplying GCC Region</p>
              <p className="text-white/75 text-xs mt-1">omandisposables.com</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 py-4 px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-white/75 text-xs">
          <p>© {new Date().getFullYear()} omandisposables.com. Muscat, Oman.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy-policy" className="hover:text-white/90 transition-colors cursor-pointer">Privacy Policy</Link>
            <span>Bulk Ready | GCC Supply</span>
          </div>
        </div>
        <div className="max-w-7xl mx-auto mt-2 text-center">
          <p className="text-white/35 text-xs">
            omandisposables.com operates under Attiyaf Al Jazeera Household Utensils LLC, registered in Oman.
          </p>
        </div>
      </div>
    </footer>
  );
}
